import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const LocalLibraryIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"local_library"} ref={ref}/>
});

LocalLibraryIcon.displayName = "LocalLibraryIcon";
